import script from "./orderManage.vue?vue&type=script&setup=true&lang=js"
export * from "./orderManage.vue?vue&type=script&setup=true&lang=js"

import "./orderManage.vue?vue&type=style&index=0&id=a6997e88&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6997e88"]])

export default __exports__